import { type TFunction } from "i18next";
import { ChevronRight } from "lucide-react";

import { WFPButton } from "@/components/ui/button";

import { ACTION_BUTTON_CLASS } from "./constants";
import { type AggregatorListItem } from "./types";

const ActionsCell = ({
  aggregator,
  onClickView,
  t,
}: {
  aggregator: AggregatorListItem;
  onClickView?: (aggregator: AggregatorListItem) => void;
  t: TFunction;
}) => {
  const hasId = aggregator.id !== undefined && aggregator.id !== null;
  const canView = hasId && Boolean(onClickView);

  return (
    <div className="flex items-center gap-2">
      <WFPButton
        type="button"
        variant="outline"
        size="sm"
        className={ACTION_BUTTON_CLASS}
        onClick={() => {
          if (canView) {
            onClickView?.(aggregator);
          }
        }}
      >
        {t("common.view")}
        <ChevronRight className="size-4" aria-hidden="true" />
      </WFPButton>
    </div>
  );
};

export { ActionsCell };
